import { useTranslation } from 'react-i18next';
import { LabAnalysisCataloguePanel } from '@/components/lab/LabAnalysisCataloguePanel';
import { useActiveClinic } from '@/lib/activeClinic';
import { TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';

export function LabAnalysisCatalogue(_props: { embedded?: boolean } = {}) {
  const { t } = useTranslation();
  const { activeClinicId } = useActiveClinic();

  return (
    <div>
      <div className="flex w-full min-w-0 flex-wrap items-start justify-between gap-s3 nav:flex-nowrap nav:items-center min-h-10">
        <div className="shrink-0">
          <h1 className={cn(TYPE.title, 'text-ds-text')}>{t('patients.lab.catalogue_title')}</h1>
        </div>
      </div>
      <div className="mt-s5">
        {activeClinicId ? (
          <LabAnalysisCataloguePanel clinicId={activeClinicId} showTitle={false} />
        ) : (
          <p className="text-sm text-ds-muted">{t('patients.lab.catalogue_no_clinic')}</p>
        )}
      </div>
    </div>
  );
}
